
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import MissionOrderDetailsModal from "@/components/mission-orders/details-modal.vue";
import MissionOrderDelegateModal from "@/components/mission-orders/delegate-modal.vue";
import { Getter } from "vuex-class";
import MissionOrderAssignModal from "@/components/mission-orders/assign-modal.vue";
import MissionOrderUnassignModal from "@/components/mission-orders/unassign-modal.vue";
import { mdiAccountMultipleMinus, mdiAccountMultiplePlus, mdiClipboardArrowRightOutline } from "@mdi/js";
import SvgIcon from "@jamescoyle/vue-icon";
import { ROWS_PER_PAGE } from "@/utils/constants";

@Component({
  components: {
    MissionOrderDetailsModal,
    MissionOrderDelegateModal,
    MissionOrderAssignModal,
    MissionOrderUnassignModal,
    SvgIcon,
  },
})
export default class MissionOrdersTable extends Vue {

  get selectedMissionOrderDelegatedCompany(): any | null {
    return this.selectedMissionOrder?.DelegatedMissionOrder?.ServiceCompany;
  }

  get displayBuildingLink(): boolean {
    return !this.building?.id && this.canDoInEnvCompany("READ_BUILDING");
  }

  @Prop({default: null})
  public clientCompanyId: number;

  @Prop({default: null})
  public serviceCompanyId: number;

  @Prop({default: null})
  public building: any;

  @Prop({default: null})
  public keyGroup: any;

  @Getter private isMobile: boolean;

  @Getter private envCompanyId: number|null;
  @Getter private canDoInEnvCompany: (right: string) => boolean;

  private pagination = {
    page: 1,
    itemsPerPage: 10,
  };
  private search: string = "";
  private loading: boolean = false;
  private totalItem: number = 0;
  private missionOrdersList: any[] = [];
  private selectedMissionOrder: any = null;
  private displayedModal: string = null;
  private headers: object[] = [];
  private icons = {
    mdiAccountMultipleMinus,
    mdiAccountMultiplePlus,
    mdiClipboardArrowRightOutline,
  };

  private ROWS_PER_PAGE = ROWS_PER_PAGE;

  @Watch("clientCompanyId")
  public handlerCompaniesId() {
    if (this.clientCompanyId) {
      this.reset();
    }
  }

  private getMissionOrdersList() {
    this.loading = true;
    return this.$store.dispatch("missionOrders/read", {
      // Filters
      envCompanyId: this.envCompanyId,
      clientCompanyId: this.clientCompanyId,
      serviceCompanyId: this.serviceCompanyId,
      buildingId: this.building?.id,
      keyGroupId: this.keyGroup?.id,
      // Pagination
      page: this.pagination.page,
      itemsPerPage: this.pagination.itemsPerPage,
      search: this.search || null,
    })
      .then((data) => {
        this.missionOrdersList = data.rows;
        this.totalItem = data.count;
        this.resetHeaders();
      })
      .finally(() => {
        this.loading = false;
        this.$emit("loaded");
      });
  }

  private openModal(modal: string, missionOrder: any) {
    this.selectedMissionOrder = missionOrder;
    this.displayedModal = modal;
  }

  private closeModals() {
    this.displayedModal = null;
    this.selectedMissionOrder = null;
  }

  private reset() {
    this.closeModals();
    this.pagination.page = 1;
    this.pagination.itemsPerPage = 10;
    this.search = "";
    this.loading = false;
    this.selectedMissionOrder = null;
    this.getMissionOrdersList();
  }

  private resetHeaders(): void {
    this.headers = [
      { text: this.$t("common.type"), value: "type", sortable: false },
      { text: this.$t("common.startDate"), value: "KeyAccess.startDate", sortable: false },
      { text: this.$t("common.endDate"), value: "KeyAccess.endDate", sortable: false },
    ];
    if (!this.building?.id) {
      this.headers.push({
        text: this.$t("MissionOrders.building"),
        value: "Building.name",
        sortable: false,
      });
    }
    if (!this.serviceCompanyId) {
      this.headers.unshift({
        text: this.$t("MissionOrders.serviceCompany"),
        value: "ServiceCompany.name",
        sortable: false,
      });
      this.headers.push();
      if (!this.keyGroup?.id) {
        this.headers.push({
          text: this.$t("MissionOrders.keyGroup"),
          value: "KeyGroupName",
          sortable: false,
        });
      }
    }
    if (!this.clientCompanyId) {
      this.headers.unshift({
        text: this.$t("MissionOrders.clientCompany"),
        value: "ClientCompany.name",
        sortable: false,
      });
      this.headers.push({
        text: this.$t("MissionOrders.userGroup"),
        value: "KeyAccess.UserGroup.name",
        sortable: false,
      });
      this.headers.push({
        text: this.$t("MissionOrders.delegatedTo"),
        value: "DelegatedMissionOrder.ServiceCompany.name",
        sortable: false,
      });
    }
    this.headers.push({ value: "action", sortable: false });
  }

  /**
   * Description: Handles the key press event for the 'Enter' key.
   *
   * @param {object} e - The event object representing the key press.
   *
   * @return {void}
   */
  private enterKeyPress(e) {
    if (e.keyCode === 13) {
      this.searchHandler();
    }
  }

  /**
   * Resets the search page to 1 and retrieves the Build Bing List.
   *
   * @returns {void}
   */
  private searchHandler(): void {
    this.pagination.page = 1;
    this.getMissionOrdersList();
  }

}
